/* @flow */

export default {
  root: {
    fill: 'inherit',
    stroke: 'inherit',
  },
};
